import React from "react";
import { useSite } from "../../../context/SiteContext";
import { useFb } from "./shared";
import PagesSection from "./PagesSection";
import ScheduleSection from "./ScheduleSection";
import PicturesSection from "./PicturesSection";
import TemplatesSection from "./TemplatesSection";
import FollowupsSection from "./FollowupsSection";
import TasksSection from "./TasksSection";
import AdsSection from "./AdsSection";

const VIEWS = { schedule: ScheduleSection, pictures: PicturesSection, templates: TemplatesSection, followups: FollowupsSection, tasks: TasksSection, ads: AdsSection };

export default function FbTab({ section }) {
  const pages = useFb("pages");
  const { rawContent, content } = useSite();
  const c = rawContent || content || {};
  const View = VIEWS[section];
  return (
    <div className="space-y-5" data-testid={`admin-fb-${section}`}>
      {section === "schedule" && <p className="max-w-3xl text-[14px] text-[#5b6d6a]">Plan everything for your Facebook pages here, then copy and post by hand. Each page gets its own chat link so you can see which page brings in chats and quotes.</p>}
      {section === "pages" ? <PagesSection store={pages} c={c} /> : View ? <View pages={pages.items} c={c} /> : null}
    </div>
  );
}
